import { render, staticRenderFns } from "./WeightLossAfterCheckout.vue?vue&type=template&id=220fb994&scoped=true"
import script from "./WeightLossAfterCheckout.vue?vue&type=script&lang=js"
export * from "./WeightLossAfterCheckout.vue?vue&type=script&lang=js"
import style0 from "./WeightLossAfterCheckout.vue?vue&type=style&index=0&id=220fb994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220fb994",
  null
  
)

export default component.exports